export const USER_COOKIE_TOKEN_NAME = 'token';
export const USER_COOKIE_REFRESH_TOKEN_NAME = 'refreshToken';
export const COOKIE_CONSENT_NAME = 'cookieConsent';
